import { render } from "./PrimeiroAcesso.vue?vue&type=template&id=6def7145&scoped=true"
import script from "./PrimeiroAcesso.vue?vue&type=script&lang=js"
export * from "./PrimeiroAcesso.vue?vue&type=script&lang=js"

import "./PrimeiroAcesso.vue?vue&type=style&index=0&id=6def7145&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6def7145"]])

export default __exports__